<template>
  <div class="navbar">
    <div class="container">
      <div class="main-header">
        <div class="logo-link" @click="redirectToHomePage">
          <button
            v-if="!isHomeVersionBar"
            type="button"
            class="btn-login"
            :style="[
              { 'background-color': oddColorTheme },
              { color: colorsGeneralSecondary }
            ]"
          >
            <h1 class="desktop-logo text-logo">{{ $t("cart.carta") }}</h1>
          </button>
          <img
            v-if="isHomeVersionBar && settings && settings.icons"
            :src="settings.icons.logo"
            class="logo desktop-logo"
            :alt="projectName"
          />
        </div>
        <!-- </router-link> -->
        <div v-if="cartIsVisible" class="cart-button1">
          <v-select
            v-if="isActiveTranslator"
            v-model="language"
            @change="onSelectLanguage"
            :class="{ 'translator-select-field': isActiveTranslator }"
            :items="languages"
            dense
            hide-details
          >
          </v-select>
          <router-link
            :to="'/receipt'"
            v-if="!canBeDirectPayment && !isOnlyMenu"
            :event="!loadingGlobal ? 'click' : ''"
          >
            <button
              type="button"
              v-if="!isActiveSoloCarta"
              class="receipt-button"
              style="font-size: 22px"
              :style="[{ color: oddColorTheme }]"
            >
              <font-awesome-icon
                class="odd-color"
                icon="credit-card"
                :style="[{ color: oddColorTheme }, { fontSize: 24 }]"
              />
              <span
                v-if="getUnpaidTotalPrice"
                class="total-quantity-receipt"
                :style="{ 'border-radius': buttonBorderRadiusTheme }"
              >
                {{ receiptOrdersCount }}
              </span>
            </button>
          </router-link>
          <router-link
            :to="'/recent'"
            v-if="canBeDirectPayment && !isOnlyMenu"
            :event="!loadingGlobal ? 'click' : ''"
          >
            <button
              type="button"
              v-if="!isActiveSoloCarta"
              class="recent-button"
              style="font-size: 22px"
              :style="[{ color: oddColorTheme }]"
            >
              <font-awesome-icon
                class="odd-color"
                icon="shopping-bag"
                :style="[{ color: oddColorTheme }, { fontSize: 24 }]"
              />
              <span
                v-if="!!totalCustomerOrders"
                class="total-quantity"
                :style="{ 'border-radius': buttonBorderRadiusTheme }"
              >
                {{ totalCustomerOrders }}
              </span>
            </button>
          </router-link>
          <button
            type="button"
            v-if="!isActiveSoloCarta && !isOnlyMenu"
            class="cart-button"
            @click="toggleCart($event)"
            :style="{ color: oddColorTheme }"
          >
            <font-awesome-icon
              class="odd-color"
              icon="shopping-cart"
              :style="{ fontSize: 24 }"
            />
            <span v-if="!!totalQuantity" class="total-quantity">
              {{ totalQuantity }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { drinksCollection } from "@/collections/drinks";
import { qrCollection } from "@/collections/qrs";
import { ordersCollection } from "@/collections/orders";
import { ordersTotalByTableCollection } from "@/collections/ordersTotalByTable";
import { dessertCollection } from "@/collections/dessert";
import { foodCollection } from "@/collections/food";

export default {
  name: "Navbar",
  props: {
    cartIsVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      drinksCollection: [],
      foodCollection: [],
      dessertCollection: [],
      qrCollection: [],
      language: null,
      languages: [
        {
          text: "ES",
          value: "es"
        },
        {
          text: "EN",
          value: "en"
        },
        {
          text: "DE",
          value: "de"
        },
        {
          text: "IT",
          value: "it"
        },
        {
          text: "FR",
          value: "fr"
        }
      ]
    };
  },
  firestore() {
    return {
      drinksCollection: drinksCollection,
      foodCollection: foodCollection,
      dessertCollection: dessertCollection,
      qrCollection: qrCollection,
      ordersCollection: ordersCollection
        .where("tableQR", "==", this.tableQR)
        .where("isOpen", "==", true)
        .orderBy("time", "desc"),
      ordersTotalByTable: ordersTotalByTableCollection.where(
        "tableQR",
        "==",
        this.tableQR
      )
    };
  },
  computed: {
    getUnpaidTotalPrice() {
      let orderByTable = this.ordersTotalByTable.find(
        x => x.tableQR === this.tableQR
      );
      return parseFloat((orderByTable ? orderByTable.remaining : 0).toFixed(2));
    },
    receiptOrdersCount() {
      let orders = this.ordersCollection?.filter(x => x.metadata);
      return Object.keys(this.arrayGroupBy(orders, "time")).length;
    },
    canBeDirectPayment() {
      let selectedQR = this.tableQR;
      let table = this.qrCollection.find(x => x.table === selectedQR);
      let zone;
      if (table) {
        zone = this.qrZones.find(x => x.id === table.zone_id);
      }
      return zone ? zone.acceptDirectPayment : false;
    },
    tableQR() {
      return this.$store.state.tableQR;
    },
    homeUrl() {
      return `/?qr=${this.tableQR}`;
    },
    totalCustomerOrders() {
      return this.$store.getters.myOrdersQuantity;
    },
    totalQuantity() {
      if (
        this.drinksCollection.length === 0 ||
        this.foodCollection.length === 0
      )
        return 0;

      let products = {
        drinks: this.drinksCollection,
        food: this.foodCollection,
        dessert: this.dessertCollection
      };
      return this.$store.getters.getCartTotalQuantity(products);
    }
  },
  updated() {
    // TODO: Find better solution to only declare the variables 1x (e.g. refs)
    // eslint-disable-next-line no-unused-vars
    const cart = document.querySelector(".cart");
    if (document.querySelector(".cart-button.cart-shown")) {
      this.resizeCartPanel();
    }
  },
  mounted() {
    this.language = this.$store.getters.language;
    this.$i18n.locale = this.$store.getters.language;
  },
  methods: {
    onSelectLanguage(value) {
      this.$store.commit("setLanguage", value);
      this.$i18n.locale = value;
    },
    redirectToHomePage() {
      if (this.isOnlyMenu) {
        return;
      }
      location.href = this.homeUrl;
    },
    toggleCart() {
      const toggleCartButton = document.querySelector(".cart-button");
      const cart = document.querySelector(".cart");
      if (!(cart || toggleCartButton)) return;

      if (toggleCartButton.classList.contains("cart-shown")) {
        toggleCartButton.classList.remove("cart-shown");
        cart.style.height = "0px";
      } else {
        toggleCartButton.classList.add("cart-shown");
        this.resizeCartPanel();
        document
          .getElementById("scroll-element")
          .scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    resizeCartPanel() {
      const cart = document.querySelector(".cart");
      const cartInside = document.querySelector(".cart-inside-wrapper");
      cart.style.height = `${cartInside.scrollHeight}px`;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
